import { ref, reactive, computed, onUpdated } from 'vue'

const product = ref(null)
const currentImage = ref(null)
const specsPDF = ref(null)
const finish = ref(null)
const finishCategory = ref(null)
const quantity = ref(1)
const size = ref(null)
const designOptions = ref([])
// Group-aware design selections: { [groupTitle]: option } for radio, { [groupTitle]: option[] } for checkbox
const designGroupSelections = reactive({})

export const ProductState = () => {
  const setProduct = data => { product.value = data }
  const setCurrentImage = image => { currentImage.value = image }
  const setSpecsPDF = link => { specsPDF.value = link }
  const incrementQuantity = () => { if (quantity.value <= 98) quantity.value++ }
  const decrementQuantity = () => { if (quantity.value >= 2) quantity.value-- }
  const setFinish = data => { finish.value = data }
  const setFinishCategory = data => { finishCategory.value = data }
  const setSize = data => { size.value = data }
  const addDesignOption = option => { if (!designOptions.value.find(x => x.value === option.value)) { designOptions.value = [...designOptions.value, option] } }
  const removeDesignOption = option => { designOptions.value = designOptions.value.filter(x => x.value !== option.value) }

  // Group-aware: radio (pick one per group)
  const setDesignGroupSelection = (groupTitle, option) => {
    designGroupSelections[groupTitle] = option
  }
  // Group-aware: checkbox (toggle within group)
  const toggleDesignGroupOption = (groupTitle, option) => {
    if (!designGroupSelections[groupTitle]) {
      designGroupSelections[groupTitle] = [option]
    } else {
      const idx = designGroupSelections[groupTitle].findIndex(x => x.value === option.value)
      if (idx >= 0) {
        designGroupSelections[groupTitle].splice(idx, 1)
      } else {
        designGroupSelections[groupTitle].push(option)
      }
    }
  }
  // Merged list of all design selections (flat + grouped) for quote/cart
  const allDesignOptions = computed(() => {
    const grouped = []
    for (const key in designGroupSelections) {
      const val = designGroupSelections[key]
      if (Array.isArray(val)) {
        grouped.push(...val)
      } else if (val) {
        grouped.push(val)
      }
    }
    return [...designOptions.value, ...grouped]
  })
  const allFieldsFilled = computed(() => {
    if (!product.value) return false
    if (!currentImage.value) return false
    if (!finish.value) return false
    if (!quantity.value) return false
    if (!size.value) return false
    if (!size.value.diameter) {
      if (!size.value.dimensions.length) return false
      if (!size.value.dimensions.width) return false
      if (!size.value.dimensions.height) return false
    }
    if (size.value.diameter) {
      if (size.value.diameter === 0) return false
      if (!size.value.dimensions.height) return false
    }
    return true
  })
  const clearState = () => {
    product.value = null
    currentImage.value = null
    finish.value = null
    specsPDF.value = null
    quantity.value = 1
    size.value = null
    designOptions.value = []
    Object.keys(designGroupSelections).forEach(key => delete designGroupSelections[key])
  }

  // onUpdated(() => {
  //   console.log({
  //     product: product.value,
  //     currentImage: currentImage.value,
  //     finish: finish.value,
  //     specsPDF: specsPDF.value,
  //     quantity: quantity.value,
  //     size: size.value,
  //     designOptions: designOptions.value,
  //     allFieldsFilled: allFieldsFilled.value
  //   })
  // })

  return {
    product,
    currentImage,
    finish,
    finishCategory,
    specsPDF,
    quantity,
    size,
    designOptions,
    designGroupSelections,
    allDesignOptions,
    allFieldsFilled,
    setProduct,
    setCurrentImage,
    setSpecsPDF,
    incrementQuantity,
    decrementQuantity,
    setFinish,
    setFinishCategory,
    setSize,
    addDesignOption,
    removeDesignOption,
    setDesignGroupSelection,
    toggleDesignGroupOption,
    clearState
  }
}
